__turbopack_context__.v({
  "activityItem": "ActivityItem-module__WrHXCW__activityItem",
});
